import {
  COURSE_WIZARD_CURRENT_STEP,
  COURSE_WIZARD_ALL_STEPS,
  COURSE_ALL_LIST,
  ALL_COURSE_NAMES,
  COURSE_ALL_UNPUBLISHED_LIST,
  COURSE_LIST,
  QUIZ_LIST,
  COURSE_LESSON_MODAL,
  LESSON_TEXT_ATTACHMENT,
  LESSON_DOCUMENT_ATTACHMENT,
  LESSON_VIDEO_ATTACHMENT,
  LESSON_AUDIO_ATTACHMENT,
  LESSON_LINK_ATTACHMENT,
  COURSE_CURRENT_CHAPTER_OPENED,
  TEMPORARY_CHAPTER_RANKING,
  TEMPORARY_LESSON_RANKING,
  EDIT_LESSON_DATA,
  CHAPTER_MODAL,
  COURSE_MODAL,
} from "CourseAction";

export function courseWizardStep(state = {}, action) {
  switch (action.type) {
    case COURSE_WIZARD_CURRENT_STEP:
      return action.payload;
    default:
      return state;
  }
}

export function courseWizardAllSteps(state = [], action) {
  switch (action.type) {
    case COURSE_WIZARD_ALL_STEPS:
      return action.payload;
    default:
      return state;
  }
}

export function allCourseList(state = {}, action) {
  switch (action.type) {
    case COURSE_ALL_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function allCourseName(state = {}, action) {
  switch (action.type) {
    case ALL_COURSE_NAMES:
      return action.payload;
    default:
      return state;
  }
}

export function allUnpublishedCourseList(state = {}, action) {
  switch (action.type) {
    case COURSE_ALL_UNPUBLISHED_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function courseList(state = {}, action) {
  switch (action.type) {
    case COURSE_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function quizList(state = {}, action) {
  switch (action.type) {
    case QUIZ_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function courseLessonModal(state = {}, action) {
  switch (action.type) {
    case COURSE_LESSON_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function lessonTextAttachment(state = {}, action) {
  switch (action.type) {
    case LESSON_TEXT_ATTACHMENT:
      return action.payload;
    default:
      return state;
  }
}

export function lessonDocumentAttachment(state = {}, action) {
  switch (action.type) {
    case LESSON_DOCUMENT_ATTACHMENT:
      return action.payload;
    default:
      return state;
  }
}

export function lessonVideoAttachment(state = {}, action) {
  switch (action.type) {
    case LESSON_VIDEO_ATTACHMENT:
      return action.payload;
    default:
      return state;
  }
}

export function lessonAudioAttachment(state = {}, action) {
  switch (action.type) {
    case LESSON_AUDIO_ATTACHMENT:
      return action.payload;
    default:
      return state;
  }
}

export function lessonLinkAttachment(state = {}, action) {
  switch (action.type) {
    case LESSON_LINK_ATTACHMENT:
      return action.payload;
    default:
      return state;
  }
}

export function currentChapterOpen(state = {}, action) {
  switch (action.type) {
    case COURSE_CURRENT_CHAPTER_OPENED:
      return action.payload;
    default:
      return state;
  }
}

export function tempChapterRanking(state = {}, action) {
  switch (action.type) {
    case TEMPORARY_CHAPTER_RANKING:
      return action.payload;
    default:
      return state;
  }
}

export function tempLessonRanking(state = {}, action) {
  switch (action.type) {
    case TEMPORARY_LESSON_RANKING:
      return action.payload;
    default:
      return state;
  }
}

export function editLessonData(state = {}, action) {
  switch (action.type) {
    case EDIT_LESSON_DATA:
      return action.payload;
    default:
      return state;
  }
}

export function chapterModal(state = {}, action) {
  switch (action.type) {
    case CHAPTER_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function courseModal(state = {}, action) {
  switch (action.type) {
    case COURSE_MODAL:
      return action.payload;
    default:
      return state;
  }
}
